export default "__VITE_ASSET__NhIqaQ9v__"